import { createApi } from '@reduxjs/toolkit/query/react'
import { createBaseQueryWithReauth } from 'store/auth/base-query-with-reauth'
import { getUserId } from 'utils/common'
import {
  DashboardSummary,
  RecentDashboardOrder,
  RecentDashboardTrip,
} from './dashboard.types'

const baseUrl = `${process.env.REACT_APP_ORDER_SERVICE_API}`

export const dashboardApi = createApi({
  reducerPath: 'dashboardApi',
  baseQuery: createBaseQueryWithReauth(baseUrl!),
  endpoints: (builder) => ({
    getDashboardSummary: builder.query<DashboardSummary, void>({
      query: () => ({
        url: 'osapi/v1/dashboard/summary',
        method: 'GET',
        headers: {
          userId: getUserId(),
        },
      }),
    }),
    getRecentDashboardOrders: builder.query<RecentDashboardOrder[], void>({
      query: () => ({
        url: 'osapi/v1/dashboard/recent-orders',
        method: 'GET',
        headers: {
          userId: getUserId(),
        },
      }),
    }),
    getRecentDashboardTrips: builder.query<RecentDashboardTrip[], void>({
      query: () => ({
        url: 'osapi/v1/dashboard/recent-trips',
        method: 'GET',
        headers: {
          userId: getUserId(),
        },
      }),
    }),
  }),
})

export const {
  useGetDashboardSummaryQuery,
  useGetRecentDashboardOrdersQuery,
  useGetRecentDashboardTripsQuery,
} = dashboardApi


